import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { OLIDetail } from 'models'

export interface VasDetail {
  id: number
  name: string
  productId: string
  isEditable: boolean | null
  deploymentDate: string | null
  liveDate: string | null
  acquirerId: string | null
  status: string
  acquirerBankName: string | null
  opportunityLineItemId: string
}

interface MapVasState {
  allOliVasMap: Record<string, OLIDetail[]>
  isGetOliLoading: boolean
  mappedVasesMap: Record<number, VasDetail[]>
  selectedPosPerStore: Record<number, Record<number, number>>
}

const initialState: MapVasState = {
  allOliVasMap: {},
  isGetOliLoading: false,
  mappedVasesMap: {},
  selectedPosPerStore: {},
}

const mapVasSlice = createSlice({
  name: 'mapVasSlice',
  initialState,
  reducers: {
    setAllOliVasMap: (state, action: PayloadAction<Record<string, OLIDetail[]>>) => {
      state.allOliVasMap = action.payload
    },
    setIsGetOliLoading: (state, action: PayloadAction<boolean>) => {
      state.isGetOliLoading = action.payload
    },
    setMappedVasesMap: (state, action: PayloadAction<Record<number, VasDetail[]>>) => {
      state.mappedVasesMap = action.payload
    },
    setSelectedPosPerStore: (
      state,
      action: PayloadAction<Record<number, Record<number, number>>>,
    ) => {
      state.selectedPosPerStore = action.payload
    },
  },
})

export const { setAllOliVasMap, setIsGetOliLoading, setMappedVasesMap, setSelectedPosPerStore } =
  mapVasSlice.actions
export default mapVasSlice.reducer
